import { ASSET_PATHS } from '../../utils/assetPath';

import './CSVFileIcon.css';

interface CSVFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function CSVFileIcon({ className = '', size = 32, ariaLabel = 'CSV file' }: CSVFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`csv-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.CSV_FILE_ICON}
      width={size}
    />
  );
}

export default CSVFileIcon;
